// extracted by mini-css-extract-plugin
export default {"resendButton":"bHjxRBNnmN1Us1b0qR4s"};